import React, { useEffect, useState } from 'react';
import cc from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '../../Switch/Switch';
import { ITransactionCardProps } from './transactionCard.model';

import styles from './TransactionCard.module.css';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    margin: 0,
    paddingTop: 16,
    borderTop: '1px solid #CBCBDA',
  },
  label: {
    fontFamily: 'var(--ff-etelka-text)',
    fontSize: 14,
    lineHeight: '24px',
    '&.Mui-disabled': {
      color: '#000',
    },
  },
});

const TransactionCard = ({
  header,
  fields,
  askSaveBeneficiary,
  onToggleSaveBeneficiary,
  disableSaveBeneficiary,
  defaultSaveBeneficiary,
  className,
}: ITransactionCardProps) => {
  const [saveBeneficiary, setSaveBeneficiary] = useState(defaultSaveBeneficiary ?? false);

  const toggleSaveBeneficiary = () => setSaveBeneficiary((prev) => !prev);

  useEffect(() => {
    if (onToggleSaveBeneficiary) {
      onToggleSaveBeneficiary(saveBeneficiary);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveBeneficiary]);

  const classes = useStyles();

  const renderSaveControl = () => {
    if (!askSaveBeneficiary || disableSaveBeneficiary) {
      return null;
    }
    return (
      <FormControlLabel
        control={<Switch />}
        checked={saveBeneficiary}
        onChange={toggleSaveBeneficiary}
        label="Save Beneficiary?"
        labelPlacement="start"
        disabled={disableSaveBeneficiary}
        classes={classes}
      />
    );
  };

  const getRows = () =>
    fields.map(({ label, value }) => (
      <div key={String(label)} className={styles.line}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>{value}</div>
      </div>
    ));

  return (
    <section className={cc(styles.card, className)}>
      {header}
      {getRows()}
      {renderSaveControl()}
    </section>
  );
};

export default TransactionCard;
